import TripItemRailTicketsQuestion from './trip-item-rail-tickets-question-component';

import './trip-item-rail-tickets-question.scss';

const MODULE_NAME = 'app.trip.rail-tickets-question';
const module = angular.module(MODULE_NAME, [])
    .directive(TripItemRailTicketsQuestion.DIRECTIVE_NAME, TripItemRailTicketsQuestion);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-cancellation/trip-item-rail-tickets-question/trip-item-rail-tickets-question-module.js